import { Link } from "@/lib/router-compat";
import Layout from "@/components/Layout";
import PageSEO from "@/components/PageSEO";
import { breadcrumbSchema } from "@/lib/seo";
import PageHero from "@/components/PageHero";
import {
  mainPages,
  blogPages,
  electricalPages,
  hvacPages,
  energyPages,
  industryPages,
  stadiumPages,
  guidePages,
  serviceAreaPages,
  type SitemapEntry,
} from "@/data/sitemap-urls";

// Page is noindex, follow — every link here must stay followable.
const SitemapList = ({ entries }: { entries: SitemapEntry[] }) => (
  <ul className="space-y-1 text-sm font-body">
    {entries.map(e => (
      <li key={e.path}>
        <Link
          to={e.path}
          className={`text-muted-foreground hover:text-primary${e.path.split("/").length <= 2 ? " font-semibold" : ""}`}
        >
          {e.label}
        </Link>
      </li>
    ))}
  </ul>
);

const Section = ({ title, entries }: { title: string; entries: SitemapEntry[] }) => (
  <>
    <h2 id={title.toLowerCase().replace(/[^a-z0-9]+/g, "-")} className="font-heading font-bold text-lg mb-3 text-primary">{title}</h2>
    <SitemapList entries={entries} />
  </>
);

const SitemapPage = () => (
  <Layout>
    <PageSEO title="Sitemap | Hadley Energy Solutions" description="Full sitemap for Hadley Energy Solutions — browse all electrical, HVAC, energy management services, and service area pages. Louisville, KY." canonical="/sitemap" noIndex schemas={[breadcrumbSchema([{ name: "Home", url: "/" }, { name: "Sitemap", url: "/sitemap" }])]} />
    <PageHero title="Sitemap" eyebrow="SITEMAP" />
    <section className="section-padding"><div className="container max-w-4xl">
      <div className="grid gap-x-10 gap-y-8 sm:grid-cols-2 lg:grid-cols-4 [&>div]:border-t [&>div]:border-border [&>div]:pt-5">
        <div>
          <Section title="Main Pages" entries={mainPages} />
          <div className="mt-6"><Section title="Blog" entries={blogPages} /></div>
        </div>
        <div>
          <Section title="Electrical Services" entries={electricalPages} />
        </div>
        <div>
          <Section title="HVAC Services" entries={hvacPages} />
          <div className="mt-6"><Section title="Energy Management" entries={energyPages} /></div>
        </div>
        <div>
          <Section title="Industries" entries={industryPages} />
          <div className="mt-6"><Section title="Stadium & Sports Lighting" entries={stadiumPages} /></div>
        </div>
        <div>
          <Section title="Authority Guides" entries={guidePages} />
          <div className="mt-6"><Section title="Service Areas" entries={serviceAreaPages} /></div>
        </div>
      </div>
    </div></section>
  </Layout>
);

export default SitemapPage;
